import { PropsWithChildren, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const PortalWrapper = ({ children }: PropsWithChildren): JSX.Element => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  const portalRoot = document?.getElementsByTagName('body')[0];
  return portalRoot ? createPortal(children, portalRoot) : null;
};

export default PortalWrapper;
